import Vue from 'vue'
import VueRouter from 'vue-router' //接收VueRouter为构造函数


Vue.use(VueRouter) //全局使用路由


let routes = [
    // 一级路由
    {
        path: '/login',
        component: () =>
            import ('../pages/login/login.vue'),
    },

    {
        path: '/index',
        component: () =>
            import ('../pages/index'),
        // 二级路由
        children: [


            {
                path: 'home',
                component: () =>
                    import ('../views/home/index'),
                meta: {
                    title: '运行控制席',
                    permission: {
                        switchLayer: [
                            'customLine',
                            'dynamicairspace',
                            'listbyposition',
                            'line',
                            'router',
                            'controlArea',
                            // 'controlRoom',
                            'lowAlt',
                            'Air',
                            'alarm',
                            'customLayer',
                            'ranging',
                            // 'showWeather',
                        ]
                    }
                }
            },
            {
                path: '',
                redirect: '/index/home',
            }
        ],
    },
    { path: '*', redirect: '/index' }
]


const router = new VueRouter({
    mode: 'hash',
    routes,
});

export default router;